import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("booking/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(booking_id) {
  const url = get_api_path("booking/detail", {}, { booking_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(booking_id) {
  const url = get_api_path("booking/delete", {}, { booking_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(booking_id, data) {
  const url = get_api_path("booking/update", {}, { booking_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("booking/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};